"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.UserName = exports.MainWrapper = exports.HelpCenterLink = exports.Header = exports.FooterWrapper = exports.Footer = exports.Body = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("../../atoms/Text"));
var _atoms = require("../../atoms");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var UserName = exports.UserName = (0, _styledComponents["default"])(_Text["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: var(--font-family);\n  font-weight: 700;\n  font-size: 16px;\n"])));
var MainWrapper = exports.MainWrapper = (0, _styledComponents["default"])(_atoms.View)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  flex: 1;\n  justify-content: center;\n  padding-top: 13px;\n  padding-right: 16px;\n  padding-bottom: 13px;\n  padding-left: 16px;\n  z-index: -1;\n"])));
var Header = exports.Header = (0, _styledComponents["default"])(_Text["default"])(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: var(--font-family);\n  font-size: 20px\n  font-weight: 700;\n  line-height: 32px;\n  padding-top: 16px;\n  padding-bottom: 8px;\n  text-align: center;\n"])));
var Body = exports.Body = (0, _styledComponents["default"])(_Text["default"])(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: var(--font-family);\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.gray;
});
var Footer = exports.Footer = (0, _styledComponents["default"])(_Text["default"])(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 12px;\n  line-height: 16px;\n  font-family: var(--font-family);\n"])));
var FooterWrapper = exports.FooterWrapper = (0, _styledComponents["default"])(_atoms.View)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding-top: 0px;\n  padding-right: 16px;\n  padding-left: 16px;\n  padding-bottom: 18px;\n"])));
var HelpCenterLink = exports.HelpCenterLink = (0, _styledComponents["default"])(_Text["default"])(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 16px;\n  font-family: var(--font-family);\n  cursor: pointer;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryMedium;
});
var Wrapper = exports.Wrapper = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\ndisplay: flex;\nflex-direction: column;\nheight: 100svh;\nwidth: 100%\nmargin-top: ", ";\n\n@media screen and (min-width: 840px) {\n    height: ", ";\n  }\n"])), function (_ref3) {
  var isAdview = _ref3.isAdview;
  return isAdview ? '50px' : '0';
}, function (_ref4) {
  var isAdview = _ref4.isAdview;
  return isAdview ? 'calc(100% - 50px)' : '100%';
});